import script from "./ModuleItemView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModuleItemView.vue?vue&type=script&setup=true&lang=ts"

import "./ModuleItemView.vue?vue&type=style&index=0&id=6be7e2f0&scoped=true&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6be7e2f0"]])

export default __exports__